import React from 'react';
import PropTypes from 'prop-types';
import ProgressiveImage from "react-progressive-image";
import assets from "../../../../../util/assets";
import ViewerProfileTabComponent from "../tab";
import {Col, Collapse, Container} from "reactstrap";
import "./index.css"
import constants from "../../../../../util/constants";
import {getUserDetail, USER} from "../../../../../util/account_management";
import ButtonDesign from "../../../../ButtonDesign";
import loading_blue from "../../../../../assets/gif/loading_blue.gif";

ViewerProfileHeader.propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    pageName: PropTypes.string.isRequired,
    contentList: PropTypes.array.isRequired,
    activeTab: PropTypes.string.isRequired,
    payload: PropTypes.object.isRequired,
    toggle: PropTypes.func.isRequired,
    showLogin: PropTypes.func.isRequired,
    isForOther: PropTypes.bool
};

ViewerProfileHeader.defaultProps = {
    isForOther: false,
    isFetching:false
}

const showUserProfile = () => {
    let modal = document.getElementById("user-profile-modal");
    modal.classList.add("show");
    modal.style.display = "block";
    document.getElementsByClassName("modal-overlay")[0].style.display = "block"
};

const _getUserDetail = (props, type, key1, key2 = null) => {
    if (props.isForOther) {
        if(props.userData){
            if (key2 === null) {
                return props.userData.hasOwnProperty(key1) && props.userData[key1];
            } else {
                return props.userData.hasOwnProperty(key1) && props.userData.hasOwnProperty(key1) && props.userData[key1].hasOwnProperty(key2) && props.userData[key1][key2];
            }
        }else{
            return "";
        }
    } else {
        return getUserDetail(props, type, key1, key2);
    }


}

function ViewerProfileHeader(props) {


    return (
        <Collapse isOpen={props.pageName === constants.VIEWER_PROFILE}>


            <Col sm="12"
                 className="bg-white p-3 mb-3 rounded"
                 style={{marginTop: 24, overflow: 'hidden'}}>

                <div className="top-card-channel-image relative"
                     style={{height: 181, overflow: 'hidden'}}>

                    <div tabIndex="0"
                         id="ember2683"
                         className="channel-image--no-rounded-corners channel-image ember-view">

                        <img className="channel-image__image relative full-width"
                             id="channel-image-target-image"
                             alt="Background Image"
                             src={assets.channelImageBg}/>
                    </div>
                </div>

                <ProgressiveImage
                    delay={1000}
                    src={_getUserDetail(props,USER,"profile_pic")}
                    placeholder="placeholder">

                    {(src, loading) => {
                        return loading ? (
                                <img alt="broadcaster profile picture"
                                     className="broadcaster-profile-container-user-section-profile-pic"
                                     src={assets.user_placeholder}/>
                            ) :
                            (
                                <div
                                    className="broadcaster-profile-container-user-section-profile-pic"
                                    style={{backgroundImage: "url('" + _getUserDetail(props,USER,"profile_pic") + "')"}}>

                                </div>
                            )

                    }}
                </ProgressiveImage>

                <div className="broadcaster-profile-container-broadcaster-details">
                    <Container>
                        <div className="display-flex-flex-direction-row-no-margin">
                            <div>
                                <div className="broadcaster-profile-container-broadcaster-name">
                                    <span>{_getUserDetail(props,USER,"username")}</span>
                                </div>
                                <Collapse isOpen={true}>
                                    <span
                                        onClick={()=>{props.toggle("following")}}
                                        className="broadcaster-profile-container-broadcaster-other-details">{`${_getUserDetail(props,USER,"summary","following")} Following`}</span>
                                    <span
                                        onClick={()=>{props.toggle("subscriptions")}}
                                        className="broadcaster-profile-container-broadcaster-other-details">{`${_getUserDetail(props,USER,"summary","subscribed")} Subscriptions`} </span>
                                </Collapse>
                            </div>

                            <Collapse isOpen={true}>
                                {
                                    !props.isForOther &&
                                    <ButtonDesign
                                        btName={"EDIT PROFILE"}
                                        btColor="link"
                                        btClass="text-decoration-none bg-white rounded-0 followbtn btn-with-shadow"
                                        onclickFunction={showUserProfile}/>
                                }

                                {
                                    props.isForOther &&
                                    <ButtonDesign
                                        btName={"CHAT"}
                                        btColor="link"
                                        btClass="text-decoration-none bg-white rounded-0 followbtn btn-with-shadow"
                                        onclickFunction={() => {
                                            props.startNewChat(_getUserDetail(props, USER, "user_id"))
                                        }}>
                                        <img src={assets.messaging.chat_icon_inactive} alt={"chat"}
                                             className="user-profile-btn-img"/>
                                    </ButtonDesign>
                                }

                                {
                                    props.isForOther &&
                                    <ButtonDesign
                                        btName={_getUserDetail(props,USER,"summary","is_favourite") ? "UNFAVOURITE" : "FAVOURITE"}
                                        btColor="link"
                                        btClass="text-decoration-none bg-white rounded-0 followbtn btn-with-shadow"
                                        onclickFunction={props.favUser}>

                                        {
                                            props.isFetching
                                                ?
                                                <img src={loading_blue} alt={"Loading"} width={26} height={26}/>
                                                :
                                                <img src={assets.clipstore.home.more.more_fav} alt={"favourite"}
                                                     className="user-profile-btn-img"/>
                                        }

                                    </ButtonDesign>
                                }
                            </Collapse>
                        </div>
                    </Container>
                </div>
                <ViewerProfileTabComponent
                    activeTab={props.activeTab}
                    toggle={props.toggle}
                    isForOther={props.isForOther}
                />
            </Col>

        </Collapse>
    );
}

export default ViewerProfileHeader;